import React from "react";
import { tgIcon, vkIcon } from "../../../images";
import PsPricesDealsPage from "../../pages/pspricesDealsPage";

const btnClass =
  "mb-3 flex w-40 justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-base font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 md:mb-0";

function getBuyOnSiteUrl(region) {
  if (region === "us" || region === "pl") {
    return "https://trendy-eng-shop.ru/nintendo-eshop/shop";
  }
  return "https://trendy-eng-shop.ru/store/nintendo";
}

function NintendoDiscount() {
  return (
    <PsPricesDealsPage
      title="Скидки Nintendo Switch"
      platforms="Switch,Switch2"
      platformQuery="Switch,Switch2"
      regions={[
        { value: "us", label: "США" },
        { value: "fr", label: "Европа" },
        { value: "br", label: "Бразилия" },
        { value: "ca", label: "Канада" },
        { value: "hk", label: "Гонконг" },
        { value: "pl", label: "Польша" },
        { value: "se", label: "Швеция" },
      ]}
      ymPath="/nintendo-discount"
      renderButtons={(region) => (
        <div className="flex flex-col items-center gap-2 sm:flex-row sm:flex-wrap sm:justify-center lg:flex-nowrap">
          <a
            href={getBuyOnSiteUrl(region)}
            className={btnClass}
            target="_blank"
            rel="noreferrer"
          >
            Купить на сайте
          </a>
          <a
            href="https://t.me/trendy_eng_shop_bot?start=ref-001"
            className={btnClass}
            target="_blank"
            rel="noreferrer"
            onClick={() =>
              window.ym?.(93997310, "reachGoal", "tgClickNintendo")
            }
          >
            Купить в{" "}
            <img src={tgIcon} alt="TG" className="ml-2 h-4 w-4 sm:h-5 sm:w-5" />
          </a>
          <a
            href="https://vk.com/trendy_eng_shop"
            className={btnClass}
            target="_blank"
            rel="noreferrer"
          >
            Купить в{" "}
            <img src={vkIcon} alt="VK" className="ml-2 h-5 w-5 sm:h-6 sm:w-6" />
          </a>
        </div>
      )}
    />
  );
}

export default NintendoDiscount;
